import React, { createContext, useContext, useState, ReactNode } from "react";

type LayoutSlots = {
  toolbarSlot?: ReactNode;
  miniCalendarSlot?: ReactNode;
};

type LayoutContextType = {
  slots: LayoutSlots;
  setSlots: (slots: LayoutSlots) => void;
};

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export function LayoutProvider({ children }: { children: ReactNode }) {
  const [slots, setSlots] = useState<LayoutSlots>({});

  return (
    <LayoutContext.Provider value={{ slots, setSlots }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayoutSlots() {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error("useLayoutSlots must be used within a LayoutProvider");
  }
  return context;
}
